import axios from 'axios';

export const searchYoutube = async (search) => {
  const url = `https://youtube.teamdevz.com/search/${search}`;
  const { data } = await axios.get(url);
  return data;
};

export default searchYoutube;
